/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");
$protobuf.roots={};
var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  google: {
    nested: {
      protobuf: {
        options: {
          csharp_namespace: "Google.Protobuf.WellKnownTypes",
          go_package: "google.golang.org/protobuf/types/known/anypb",
          java_package: "com.google.protobuf",
          java_outer_classname: "AnyProto",
          java_multiple_files: true,
          objc_class_prefix: "GPB"
        },
        nested: {
          Any: {
            fields: {
              typeUrl: {
                type: "string",
                id: 1
              },
              value: {
                type: "bytes",
                id: 2
              }
            }
          }
        }
      }
    }
  },
  model: {
    nested: {
      Response: {
        oneofs: {
          _error: {
            oneof: [
              "error"
            ]
          },
          _msg: {
            oneof: [
              "msg"
            ]
          },
          _data: {
            oneof: [
              "data"
            ]
          },
          _subType: {
            oneof: [
              "subType"
            ]
          },
          _sportType: {
            oneof: [
              "sportType"
            ]
          },
          _langNumber: {
            oneof: [
              "langNumber"
            ]
          },
          _matchId: {
            oneof: [
              "matchId"
            ]
          },
          _subTypeDetail: {
            oneof: [
              "subTypeDetail"
            ]
          }
        },
        fields: {
          state: {
            type: "uint32",
            id: 1
          },
          error: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          msg: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          data: {
            type: "google.protobuf.Any",
            id: 4,
            options: {
              proto3_optional: true
            }
          },
          subType: {
            type: "int32",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          sportType: {
            type: "int32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          langNumber: {
            type: "int32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          matchId: {
            type: "uint64",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          subTypeDetail: {
            type: "int32",
            id: 9,
            options: {
              proto3_optional: true
            }
          },
          serverTimestamp: {
            type: "uint32",
            id: 10
          }
        }
      },
      Subscribe: {
        oneofs: {
          _userToken: {
            oneof: [
              "userToken"
            ]
          },
          _matchId: {
            oneof: [
              "matchId"
            ]
          },
          _comId: {
            oneof: [
              "comId"
            ]
          }
        },
        fields: {
          type: {
            type: "int32",
            id: 1
          },
          sportType: {
            type: "int32",
            id: 2
          },
          langNumber: {
            type: "int32",
            id: 3
          },
          platform: {
            type: "int32",
            id: 4
          },
          appVersion: {
            type: "string",
            id: 5
          },
          appChannel: {
            type: "string",
            id: 6
          },
          userToken: {
            type: "string",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          matchId: {
            type: "uint64",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          scoreVersion: {
            type: "uint64",
            id: 9
          },
          comId: {
            type: "uint32",
            id: 10,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballMatch: {
        oneofs: {
          _note: {
            oneof: [
              "note"
            ]
          },
          _homeLive: {
            oneof: [
              "homeLive"
            ]
          },
          _awayLive: {
            oneof: [
              "awayLive"
            ]
          },
          _daySpan: {
            oneof: [
              "daySpan"
            ]
          },
          _hasLineup: {
            oneof: [
              "hasLineup"
            ]
          },
          _hasStats: {
            oneof: [
              "hasStats"
            ]
          },
          _hasEventLive: {
            oneof: [
              "hasEventLive"
            ]
          },
          _hasLuck: {
            oneof: [
              "hasLuck"
            ]
          },
          _hasPrediction: {
            oneof: [
              "hasPrediction"
            ]
          }
        },
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          leagueId: {
            type: "uint64",
            id: 2
          },
          startTime: {
            type: "uint64",
            id: 3
          },
          startHalfTime: {
            type: "uint64",
            id: 4
          },
          injuryTime: {
            type: "uint32",
            id: 5
          },
          note: {
            type: "string",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          homeRank: {
            type: "string",
            id: 7
          },
          awayRank: {
            type: "string",
            id: 8
          },
          homeTeam: {
            type: "FootballTeam",
            id: 9
          },
          awayTeam: {
            type: "FootballTeam",
            id: 10
          },
          homeLive: {
            type: "FootballTeamLive",
            id: 11,
            options: {
              proto3_optional: true
            }
          },
          awayLive: {
            type: "FootballTeamLive",
            id: 12,
            options: {
              proto3_optional: true
            }
          },
          neutral: {
            type: "bool",
            id: 13
          },
          state: {
            type: "uint32",
            id: 14
          },
          daySpan: {
            type: "uint32",
            id: 15,
            options: {
              proto3_optional: true
            }
          },
          hasLineup: {
            type: "int32",
            id: 16,
            options: {
              proto3_optional: true
            }
          },
          hasStats: {
            type: "bool",
            id: 17,
            options: {
              proto3_optional: true
            }
          },
          hasEventLive: {
            type: "bool",
            id: 18,
            options: {
              proto3_optional: true
            }
          },
          hasLuck: {
            type: "bool",
            id: 19,
            options: {
              proto3_optional: true
            }
          },
          hasPrediction: {
            type: "bool",
            id: 20,
            options: {
              proto3_optional: true
            }
          },
          stageId: {
            type: "int32",
            id: 21
          }
        }
      },
      FootballTeamLive: {
        oneofs: {
          _yellowCard: {
            oneof: [
              "yellowCard"
            ]
          },
          _redCard: {
            oneof: [
              "redCard"
            ]
          },
          _corner: {
            oneof: [
              "corner"
            ]
          },
          _scoreHalf: {
            oneof: [
              "scoreHalf"
            ]
          },
          _scoreOt: {
            oneof: [
              "scoreOt"
            ]
          },
          _scorePen: {
            oneof: [
              "scorePen"
            ]
          },
          _scoreRound1: {
            oneof: [
              "scoreRound1"
            ]
          },
          _scoreRound2: {
            oneof: [
              "scoreRound2"
            ]
          }
        },
        fields: {
          yellowCard: {
            type: "uint32",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          redCard: {
            type: "uint32",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          corner: {
            type: "uint32",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          scoreFull: {
            type: "uint32",
            id: 4
          },
          scoreHalf: {
            type: "uint32",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          scoreOt: {
            type: "uint32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          scorePen: {
            type: "uint32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          scoreRound1: {
            type: "uint32",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          scoreRound2: {
            type: "uint32",
            id: 9,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballMatchUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          startHalfTime: {
            type: "uint64",
            id: 2
          },
          injuryTime: {
            type: "uint32",
            id: 3
          },
          note: {
            type: "string",
            id: 4
          },
          homeLive: {
            type: "FootballTeamLive",
            id: 5
          },
          awayLive: {
            type: "FootballTeamLive",
            id: 6
          },
          state: {
            type: "uint32",
            id: 7
          }
        }
      },
      FootballListUpdate: {
        fields: {
          addMatch: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          addLeague: {
            rule: "repeated",
            type: "FootballLeague",
            id: 2
          },
          removeMatch: {
            rule: "repeated",
            type: "uint64",
            id: 3
          },
          removeLeague: {
            rule: "repeated",
            type: "uint64",
            id: 4
          },
          updateMatch: {
            rule: "repeated",
            type: "FootballMatchUpdate",
            id: 5
          },
          version: {
            type: "uint64",
            id: 6
          }
        }
      },
      FootballListLuckUpdate: {
        fields: {
          asianLuckMatch: {
            keyType: "uint64",
            type: "AsianLuck",
            id: 1
          },
          threeWayLuckMatch: {
            keyType: "uint64",
            type: "ThreeWayLuck",
            id: 2
          },
          totalLuckMatch: {
            keyType: "uint64",
            type: "TotalLuck",
            id: 3
          },
          version: {
            type: "uint64",
            id: 4
          }
        }
      },
      FootballMatchDetailUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          updateMatch: {
            type: "FootballMatchUpdate",
            id: 2
          }
        }
      },
      FootballMatchLuckUpdate: {
        fields: {
          matchId: {
            type: "uint64",
            id: 1
          },
          asian: {
            rule: "repeated",
            type: "AsianLuck",
            id: 2
          },
          threeWay: {
            rule: "repeated",
            type: "ThreeWayLuck",
            id: 3
          },
          total: {
            rule: "repeated",
            type: "TotalLuck",
            id: 4
          }
        }
      },
      FootballStage: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          isCurrent: {
            type: "bool",
            id: 3
          }
        }
      },
      FootballLeague: {
        oneofs: {
          _country: {
            oneof: [
              "country"
            ]
          },
          _hasStanding: {
            oneof: [
              "hasStanding"
            ]
          },
          _ord: {
            oneof: [
              "ord"
            ]
          }
        },
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          fullName: {
            type: "string",
            id: 2
          },
          shortName: {
            type: "string",
            id: 3
          },
          color: {
            type: "string",
            id: 4
          },
          grade: {
            type: "uint32",
            id: 5
          },
          hasDt: {
            type: "bool",
            id: 6
          },
          country: {
            type: "FootballLeagueCountry",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          hasStanding: {
            type: "bool",
            id: 8,
            options: {
              proto3_optional: true
            }
          },
          ord: {
            type: "uint32",
            id: 9,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      FootballLeagueCountry: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      FootballTeam: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          fullName: {
            type: "string",
            id: 2
          },
          shortName: {
            type: "string",
            id: 3
          },
          logo: {
            type: "int32",
            id: 4
          }
        }
      },
      FootballPlayer: {
        oneofs: {
          _jerseyNumber: {
            oneof: [
              "jerseyNumber"
            ]
          },
          _age: {
            oneof: [
              "age"
            ]
          },
          _positionType: {
            oneof: [
              "positionType"
            ]
          },
          _positionName: {
            oneof: [
              "positionName"
            ]
          }
        },
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          englishName: {
            type: "string",
            id: 3
          },
          jerseyNumber: {
            type: "uint32",
            id: 4,
            options: {
              proto3_optional: true
            }
          },
          fromInfo: {
            rule: "repeated",
            type: "PlayerFrom",
            id: 5
          },
          age: {
            type: "uint32",
            id: 6,
            options: {
              proto3_optional: true
            }
          },
          positionType: {
            type: "uint32",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          positionName: {
            type: "string",
            id: 8,
            options: {
              proto3_optional: true
            }
          }
        }
      },
      PlayerFrom: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          logo: {
            type: "string",
            id: 3
          },
          type: {
            type: "uint32",
            id: 4
          }
        }
      },
      PlayerPosition: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      LuckCompany: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          hasLive: {
            type: "uint32",
            id: 3
          }
        }
      },
      LuckCompanyList: {
        fields: {
          companies: {
            rule: "repeated",
            type: "LuckCompany",
            id: 1
          }
        }
      },
      AsianLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          handInit: {
            type: "string",
            id: 2
          },
          homeInit: {
            type: "string",
            id: 3
          },
          awayInit: {
            type: "string",
            id: 4
          },
          hand: {
            type: "string",
            id: 5
          },
          home: {
            type: "string",
            id: 6
          },
          away: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      ThreeWayLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          homeInit: {
            type: "string",
            id: 2
          },
          drawInit: {
            type: "string",
            id: 3
          },
          awayInit: {
            type: "string",
            id: 4
          },
          home: {
            type: "string",
            id: 5
          },
          draw: {
            type: "string",
            id: 6
          },
          away: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      TotalLuck: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          totalInit: {
            type: "string",
            id: 2
          },
          overInit: {
            type: "string",
            id: 3
          },
          underInit: {
            type: "string",
            id: 4
          },
          total: {
            type: "string",
            id: 5
          },
          over: {
            type: "string",
            id: 6
          },
          under: {
            type: "string",
            id: 7
          },
          result: {
            type: "uint32",
            id: 8
          },
          resultInit: {
            type: "uint32",
            id: 9
          }
        }
      },
      LuckRecord: {
        fields: {
          companyId: {
            type: "string",
            id: 1
          },
          recordType: {
            type: "uint32",
            id: 2
          },
          recordValues: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          ratios: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          updateTime: {
            type: "uint64",
            id: 5
          }
        }
      },
      ListPageInfo: {
        fields: {
          page: {
            type: "uint32",
            id: 1
          },
          pageSize: {
            type: "uint32",
            id: 2
          },
          pageCount: {
            type: "uint32",
            id: 3
          },
          total: {
            type: "uint32",
            id: 4
          }
        }
      },
      Country: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      SimpleMatch: {
        fields: {
          homeId: {
            type: "int32",
            id: 1
          },
          awayId: {
            type: "int32",
            id: 2
          },
          homeName: {
            type: "string",
            id: 3
          },
          awayName: {
            type: "string",
            id: 4
          },
          homeScore: {
            type: "int32",
            id: 5
          },
          awayScore: {
            type: "int32",
            id: 6
          },
          score: {
            type: "string",
            id: 7
          },
          time: {
            type: "string",
            id: 8
          },
          leagueId: {
            type: "int32",
            id: 9
          },
          leagueName: {
            type: "string",
            id: 10
          },
          isH: {
            type: "bool",
            id: 11
          },
          res: {
            type: "int32",
            id: 12
          }
        }
      },
      FootballPredictionScore: {
        fields: {
          score: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          rate: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          total: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          rateTotal: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          scoreHit: {
            rule: "repeated",
            type: "int32",
            id: 5
          },
          totalHit: {
            rule: "repeated",
            type: "int32",
            id: 6
          },
          scoreStatCount: {
            type: "int32",
            id: 7
          },
          scoreStatHit: {
            type: "string",
            id: 8
          },
          totalStatCount: {
            type: "int32",
            id: 9
          },
          totalStatHit: {
            type: "string",
            id: 10
          }
        }
      },
      FootballPredictionWdl: {
        fields: {
          win: {
            type: "string",
            id: 1
          },
          draw: {
            type: "string",
            id: 2
          },
          loss: {
            type: "string",
            id: 3
          },
          winRecommend: {
            type: "bool",
            id: 4
          },
          drawRecommend: {
            type: "bool",
            id: 5
          },
          lossRecommend: {
            type: "bool",
            id: 6
          },
          winFlag: {
            type: "int32",
            id: 7
          },
          drawFlag: {
            type: "int32",
            id: 8
          },
          lossFlag: {
            type: "int32",
            id: 9
          },
          hit: {
            type: "int32",
            id: 10
          },
          confidence: {
            type: "string",
            id: 11
          },
          wdlStatCount: {
            type: "int32",
            id: 12
          },
          wdlStatHit: {
            type: "string",
            id: 13
          }
        }
      },
      FootballPredictionDiffer: {
        fields: {
          wdl: {
            type: "int32",
            id: 1
          },
          wdlRate: {
            type: "string",
            id: 2
          },
          ou: {
            type: "int32",
            id: 3
          },
          ouVal: {
            type: "string",
            id: 4
          },
          ouHand: {
            type: "string",
            id: 5
          },
          ah: {
            type: "int32",
            id: 6
          },
          ahVal: {
            type: "string",
            id: 7
          },
          ahHand: {
            type: "string",
            id: 8
          },
          wdlHit: {
            type: "int32",
            id: 9
          },
          ouHit: {
            type: "int32",
            id: 10
          },
          ahHit: {
            type: "int32",
            id: 11
          },
          wdlStatCount: {
            type: "int32",
            id: 12
          },
          wdlStatHit: {
            type: "string",
            id: 13
          },
          ahStatCount: {
            type: "int32",
            id: 14
          },
          ahStatHit: {
            type: "string",
            id: 15
          },
          ouStatCount: {
            type: "int32",
            id: 16
          },
          ouStatHit: {
            type: "string",
            id: 17
          }
        }
      },
      OddsTrendEntry: {
        fields: {
          bookmaker: {
            type: "string",
            id: 1
          },
          home: {
            type: "string",
            id: 2
          },
          draw: {
            type: "string",
            id: 3
          },
          away: {
            type: "string",
            id: 4
          },
          createDate: {
            type: "string",
            id: 5
          },
          createTime: {
            type: "string",
            id: 6
          }
        }
      },
      OddsTrend: {
        fields: {
          day: {
            rule: "repeated",
            type: "OddsTrendEntry",
            id: 1
          },
          time: {
            rule: "repeated",
            type: "OddsTrendEntry",
            id: 2
          }
        }
      },
      CompanyOddsStatItem: {
        fields: {
          up: {
            type: "string",
            id: 1
          },
          down: {
            type: "string",
            id: 2
          },
          flat: {
            type: "string",
            id: 3
          },
          count: {
            type: "int32",
            id: 4
          }
        }
      },
      CompanyOddsStats: {
        fields: {
          home: {
            type: "CompanyOddsStatItem",
            id: 1
          },
          away: {
            type: "CompanyOddsStatItem",
            id: 2
          },
          draw: {
            type: "CompanyOddsStatItem",
            id: 3
          },
          companyCount: {
            type: "int32",
            id: 4
          }
        }
      },
      SameOddsHistoryItem: {
        fields: {
          odds: {
            type: "string",
            id: 1
          },
          count: {
            type: "int32",
            id: 2
          },
          hitRate: {
            type: "int32",
            id: 3
          },
          hitCount: {
            type: "int32",
            id: 4
          }
        }
      },
      SameOddsHistory: {
        fields: {
          home: {
            type: "SameOddsHistoryItem",
            id: 1
          },
          away: {
            type: "SameOddsHistoryItem",
            id: 2
          },
          draw: {
            type: "SameOddsHistoryItem",
            id: 3
          }
        }
      },
      MatchLog: {
        fields: {
          win: {
            type: "int32",
            id: 1
          },
          draw: {
            type: "int32",
            id: 2
          },
          loss: {
            type: "int32",
            id: 3
          },
          list: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 4
          }
        }
      },
      WPLRes: {
        fields: {
          home: {
            type: "string",
            id: 1
          },
          draw: {
            type: "string",
            id: 2
          },
          away: {
            type: "string",
            id: 3
          },
          homeRes: {
            type: "string",
            id: 4
          },
          drawRes: {
            type: "string",
            id: 5
          },
          awayRes: {
            type: "string",
            id: 6
          },
          compHomeRes: {
            type: "string",
            id: 7
          },
          compDrawRes: {
            type: "string",
            id: 8
          },
          compAwayRes: {
            type: "string",
            id: 9
          },
          homeDiff: {
            type: "string",
            id: 10
          },
          drawDiff: {
            type: "string",
            id: 11
          },
          awayDiff: {
            type: "string",
            id: 12
          },
          predict: {
            type: "int32",
            id: 13
          },
          hitStatus: {
            type: "int32",
            id: 14
          }
        }
      },
      OverUnderRes: {
        fields: {
          over: {
            type: "string",
            id: 1
          },
          score: {
            type: "string",
            id: 2
          },
          under: {
            type: "string",
            id: 3
          },
          overRes: {
            type: "string",
            id: 4
          },
          evenRes: {
            type: "string",
            id: 5
          },
          underRes: {
            type: "string",
            id: 6
          },
          predict: {
            type: "int32",
            id: 7
          },
          hitStatus: {
            type: "int32",
            id: 8
          }
        }
      },
      HandicapRes: {
        fields: {
          home: {
            type: "string",
            id: 1
          },
          handicap: {
            type: "string",
            id: 2
          },
          away: {
            type: "string",
            id: 3
          },
          homeRes: {
            type: "string",
            id: 4
          },
          evenRes: {
            type: "string",
            id: 5
          },
          awayRes: {
            type: "string",
            id: 6
          },
          predict: {
            type: "int32",
            id: 7
          },
          hitStatus: {
            type: "int32",
            id: 8
          }
        }
      },
      TeamStats: {
        fields: {
          win: {
            type: "int32",
            id: 1
          },
          plat: {
            type: "int32",
            id: 2
          },
          count: {
            type: "int32",
            id: 3
          },
          goals: {
            type: "string",
            id: 4
          },
          loss: {
            type: "string",
            id: 5
          },
          shots: {
            type: "string",
            id: 6
          },
          corners: {
            type: "string",
            id: 7
          },
          sideGoals: {
            type: "string",
            id: 8
          },
          sideLoss: {
            type: "string",
            id: 9
          },
          winPct: {
            type: "string",
            id: 10
          },
          platPct: {
            type: "string",
            id: 11
          },
          handicapWin: {
            type: "string",
            id: 12
          },
          handicapWinPct: {
            type: "string",
            id: 13
          }
        }
      },
      ScoreOption: {
        fields: {
          score: {
            type: "string",
            id: 1
          },
          odds: {
            type: "string",
            id: 2
          },
          value: {
            type: "string",
            id: 3
          },
          isHit: {
            type: "string",
            id: 4
          }
        }
      },
      GoalLog: {
        fields: {
          goals: {
            type: "int32",
            id: 1
          },
          time: {
            type: "string",
            id: 2
          }
        }
      },
      ScoreLog: {
        fields: {
          matchInfo: {
            type: "SimpleMatch",
            id: 1
          },
          res: {
            type: "int32",
            id: 2
          },
          isH: {
            type: "int32",
            id: 3
          }
        }
      },
      UploadImageInfo: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      FootballPredictionWdlDetail: {
        fields: {
          baseInfo: {
            type: "FootballPredictionWdl",
            id: 1
          },
          oddsTrend: {
            type: "OddsTrend",
            id: 2
          },
          companyOddsStat: {
            type: "CompanyOddsStats",
            id: 3
          },
          sameOddsHistory: {
            type: "SameOddsHistory",
            id: 4
          },
          matchLog: {
            type: "MatchLog",
            id: 5
          },
          confidence: {
            type: "string",
            id: 6
          },
          updateTime: {
            type: "uint64",
            id: 7
          }
        }
      },
      FootballPredictionDifferDetail: {
        fields: {
          baseInfo: {
            type: "FootballPredictionDiffer",
            id: 1
          },
          wplRes: {
            type: "WPLRes",
            id: 2
          },
          overunderRes: {
            type: "OverUnderRes",
            id: 3
          },
          handicapRes: {
            type: "HandicapRes",
            id: 4
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 5
          },
          updateTime: {
            type: "uint64",
            id: 6
          }
        }
      },
      FootballPredictionScoreDetail: {
        fields: {
          goalTopOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 1
          },
          scoreTopOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 2
          },
          goalTotalOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 4
          },
          scoreTotalOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 5
          },
          goalsLastLog: {
            rule: "repeated",
            type: "GoalLog",
            id: 6
          },
          goalsSameLastLog: {
            rule: "repeated",
            type: "GoalLog",
            id: 7
          },
          scoreLastLog: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 8
          },
          scoreSameLastLog: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 9
          },
          avGoals: {
            keyType: "string",
            type: "TeamStats",
            id: 10
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 11
          }
        }
      },
      FootballPredictionWdlModel: {
        fields: {
          marginBaseInfo: {
            type: "FootballPredictionWdl",
            id: 1
          },
          diffBaseInfo: {
            type: "FootballPredictionDiffer",
            id: 2
          },
          oddsTrend: {
            type: "OddsTrend",
            id: 3
          },
          companyOddsStat: {
            type: "CompanyOddsStats",
            id: 4
          },
          sameOddsHistory: {
            type: "SameOddsHistory",
            id: 5
          },
          matchLog: {
            type: "MatchLog",
            id: 6
          },
          confidence: {
            type: "string",
            id: 7
          },
          wplRes: {
            type: "WPLRes",
            id: 8
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 9
          },
          maginUpdateTime: {
            type: "uint64",
            id: 10
          },
          diffUpdateTime: {
            type: "uint64",
            id: 11
          }
        }
      },
      FootballPredictionAhModel: {
        fields: {
          baseInfo: {
            type: "FootballPredictionDiffer",
            id: 1
          },
          handicapRes: {
            type: "HandicapRes",
            id: 2
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 3
          },
          updateTime: {
            type: "uint64",
            id: 4
          }
        }
      },
      FootballPredictionOuModel: {
        fields: {
          baseInfo: {
            type: "FootballPredictionDiffer",
            id: 1
          },
          overunderRes: {
            type: "OverUnderRes",
            id: 2
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 3
          },
          updateTime: {
            type: "uint64",
            id: 4
          }
        }
      },
      FootballPredictionScoreModel: {
        fields: {
          scoreTopOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 1
          },
          scoreTotalOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 2
          },
          scoreLastLog: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 3
          },
          scoreSameLastLog: {
            rule: "repeated",
            type: "SimpleMatch",
            id: 4
          },
          avGoals: {
            keyType: "string",
            type: "TeamStats",
            id: 5
          },
          last_10Goals: {
            keyType: "string",
            type: "TeamStats",
            id: 6
          }
        }
      },
      FootballPredictionGoalModel: {
        fields: {
          goalTopOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 1
          },
          goalTotalOptions: {
            rule: "repeated",
            type: "ScoreOption",
            id: 2
          },
          goalsLastLog: {
            rule: "repeated",
            type: "GoalLog",
            id: 3
          },
          goalsSameLastLog: {
            rule: "repeated",
            type: "GoalLog",
            id: 4
          },
          avGoals: {
            keyType: "string",
            type: "TeamStats",
            id: 5
          }
        }
      },
      FootballMatchInfo: {
        fields: {
          match: {
            type: "FootballMatch",
            id: 1
          },
          league: {
            type: "FootballLeague",
            id: 2
          },
          isFollow: {
            type: "bool",
            id: 3
          },
          serverTimestamp: {
            type: "uint32",
            id: 4
          },
          shareUrl: {
            type: "string",
            id: 5
          }
        }
      },
      NewsCategory: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          }
        }
      },
      News: {
        oneofs: {
          _source: {
            oneof: [
              "source"
            ]
          }
        },
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          keyword: {
            type: "string",
            id: 3
          },
          description: {
            type: "string",
            id: 4
          },
          source: {
            type: "string",
            id: 5,
            options: {
              proto3_optional: true
            }
          },
          thumbnail: {
            type: "string",
            id: 6
          },
          createTime: {
            type: "uint64",
            id: 7
          },
          content: {
            type: "string",
            id: 8
          },
          category: {
            type: "NewsCategory",
            id: 9
          }
        }
      },
      CategoryList: {
        fields: {
          categoryList: {
            rule: "repeated",
            type: "NewsCategory",
            id: 1
          }
        }
      },
      NewsList: {
        fields: {
          topList: {
            rule: "repeated",
            type: "News",
            id: 1
          },
          newsList: {
            rule: "repeated",
            type: "News",
            id: 2
          },
          pageInfo: {
            type: "ListPageInfo",
            id: 3
          }
        }
      },
      NewsListLast: {
        fields: {
          newsList: {
            rule: "repeated",
            type: "News",
            id: 1
          }
        }
      },
      FootballPrediction: {
        fields: {
          match: {
            type: "FootballMatch",
            id: 1
          },
          league: {
            type: "FootballLeague",
            id: 2
          },
          asian: {
            type: "AsianLuck",
            id: 3
          },
          asianPrev: {
            type: "AsianLuck",
            id: 4
          },
          threeWay: {
            type: "ThreeWayLuck",
            id: 5
          },
          threeWayPrev: {
            type: "ThreeWayLuck",
            id: 6
          },
          total: {
            type: "TotalLuck",
            id: 7
          },
          totalPrev: {
            type: "TotalLuck",
            id: 8
          },
          predScore: {
            type: "FootballPredictionScore",
            id: 9
          },
          predWdl: {
            type: "FootballPredictionWdl",
            id: 10
          },
          predDiffer: {
            type: "FootballPredictionDiffer",
            id: 11
          }
        }
      },
      FootballPredictionDetail: {
        oneofs: {
          modelInfo: {
            oneof: [
              "scoreDetail",
              "differDetail",
              "wdlDetail"
            ]
          }
        },
        fields: {
          match: {
            type: "FootballMatch",
            id: 1
          },
          league: {
            type: "FootballLeague",
            id: 2
          },
          scoreDetail: {
            type: "FootballPredictionScoreDetail",
            id: 3
          },
          differDetail: {
            type: "FootballPredictionDifferDetail",
            id: 4
          },
          wdlDetail: {
            type: "FootballPredictionWdlDetail",
            id: 5
          }
        }
      },
      FootballPredictionDetailV2: {
        oneofs: {
          modelInfo: {
            oneof: [
              "wdlModel",
              "ahModel",
              "ouModel",
              "scoreModel",
              "goalModel"
            ]
          }
        },
        fields: {
          match: {
            type: "FootballMatch",
            id: 1
          },
          league: {
            type: "FootballLeague",
            id: 2
          },
          wdlModel: {
            type: "FootballPredictionWdlModel",
            id: 3
          },
          ahModel: {
            type: "FootballPredictionAhModel",
            id: 4
          },
          ouModel: {
            type: "FootballPredictionOuModel",
            id: 5
          },
          scoreModel: {
            type: "FootballPredictionScoreModel",
            id: 6
          },
          goalModel: {
            type: "FootballPredictionGoalModel",
            id: 7
          },
          hasMargin: {
            type: "bool",
            id: 8
          },
          hasPoisson: {
            type: "bool",
            id: 9
          },
          hasDiff: {
            type: "bool",
            id: 10
          }
        }
      },
      FootballPredictionList: {
        fields: {
          predList: {
            rule: "repeated",
            type: "FootballPrediction",
            id: 1
          },
          margin1x2: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 2
          },
          diff1x2: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 3
          },
          diffAsian: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 4
          },
          diffOu: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 5
          },
          poissonScore: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 6
          },
          poissonGoal: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 7
          },
          predTotal: {
            type: "int32",
            id: 8
          }
        }
      },
      ModelLogItem: {
        fields: {
          value: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          updateTime: {
            type: "uint64",
            id: 2
          }
        }
      },
      ModelLog: {
        fields: {
          logList: {
            rule: "repeated",
            type: "ModelLogItem",
            id: 1
          }
        }
      },
      FootballUpdateLog: {
        fields: {
          ModelLog: {
            keyType: "string",
            type: "ModelLog",
            id: 6
          }
        }
      },
      FootballPredictionDateList: {
        fields: {
          predList: {
            rule: "repeated",
            type: "FootballPrediction",
            id: 1
          },
          leagueList: {
            rule: "repeated",
            type: "FootballLeague",
            id: 2
          },
          leagueMatchCount: {
            keyType: "int32",
            type: "int32",
            id: 3
          },
          leagueHitRate: {
            keyType: "int32",
            type: "int32",
            id: 4
          },
          leagueProfit: {
            keyType: "int32",
            type: "int32",
            id: 5
          },
          typeMatchCount: {
            keyType: "int32",
            type: "int32",
            id: 6
          },
          playMatchCount: {
            keyType: "int32",
            type: "int32",
            id: 7
          },
          margin1x2: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 8
          },
          diff1x2: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 9
          },
          diffAsian: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 10
          },
          diffOu: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 11
          },
          poissonScore: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 12
          },
          poissonGoal: {
            keyType: "int32",
            type: "PredictionRankItem",
            id: 13
          },
          liveMatchCount: {
            type: "int32",
            id: 14
          }
        }
      },
      FootballPredictionPoster: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          authorId: {
            type: "string",
            id: 3
          },
          authorAvatar: {
            type: "string",
            id: 4
          },
          authorNickName: {
            type: "string",
            id: 5
          },
          predList: {
            rule: "repeated",
            type: "FootballPrediction",
            id: 6
          },
          createTime: {
            type: "uint64",
            id: 7
          },
          predictionCnt: {
            type: "int32",
            id: 8
          },
          pv: {
            type: "int32",
            id: 9
          },
          uv: {
            type: "int32",
            id: 10
          },
          pcImage: {
            type: "string",
            id: 11
          },
          h5Image: {
            type: "string",
            id: 12
          }
        }
      },
      FootballPredictionPosterList: {
        fields: {
          posterList: {
            rule: "repeated",
            type: "FootballPredictionPoster",
            id: 1
          },
          pageInfo: {
            type: "ListPageInfo",
            id: 2
          }
        }
      },
      PredictionRank: {
        fields: {
          poissonHitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 1
          },
          poissonProfitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 2
          },
          diffHitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 3
          },
          diffProfitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 4
          },
          marginHitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 5
          },
          marginProfitList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 6
          },
          leagueList: {
            keyType: "int32",
            type: "FootballLeague",
            id: 7
          }
        }
      },
      PredictionRankItem: {
        fields: {
          leagueId: {
            type: "int32",
            id: 1
          },
          hitrate: {
            type: "string",
            id: 2
          },
          profit: {
            type: "string",
            id: 3
          },
          lastCount: {
            type: "int32",
            id: 4
          },
          lastHit: {
            type: "int32",
            id: 5
          },
          liveCount: {
            type: "int32",
            id: 6
          }
        }
      },
      FootballPredictionRelateMatch: {
        fields: {
          relateMatch: {
            rule: "repeated",
            type: "FootballMatch",
            id: 1
          },
          relateLeague: {
            keyType: "int32",
            type: "FootballLeague",
            id: 2
          }
        }
      },
      FootballPredictionHomeStat: {
        fields: {
          poisson: {
            type: "FootballPredictionHomeModelStat",
            id: 1
          },
          margin: {
            type: "FootballPredictionHomeModelStat",
            id: 2
          },
          diff: {
            type: "FootballPredictionHomeModelStat",
            id: 3
          }
        }
      },
      FootballPredictionHomeModelStat: {
        fields: {
          predCountRe30: {
            type: "int32",
            id: 1
          },
          predCountToday: {
            type: "int32",
            id: 2
          },
          predProfitRe30: {
            type: "string",
            id: 3
          },
          rankList: {
            rule: "repeated",
            type: "PredictionRankItem",
            id: 4
          },
          rankLeagueInfo: {
            keyType: "int32",
            type: "FootballLeague",
            id: 5
          }
        }
      },
      UserInfo: {
        fields: {
          info: {
            type: "UserInfoItem",
            id: 1
          }
        }
      },
      UserInfoItem: {
        oneofs: {
          _userInfoOAuth: {
            oneof: [
              "userInfoOAuth"
            ]
          }
        },
        fields: {
          uid: {
            type: "uint32",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          avatar: {
            type: "string",
            id: 3
          },
          token: {
            type: "string",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          expiresDate: {
            type: "uint32",
            id: 6
          },
          userInfoOAuth: {
            type: "UserInfoOAuthItem",
            id: 7,
            options: {
              proto3_optional: true
            }
          },
          loginType: {
            type: "uint32",
            id: 8
          }
        }
      },
      UserInfoOAuthItem: {
        oneofs: {
          _googleToken: {
            oneof: [
              "googleToken"
            ]
          },
          _facebookToken: {
            oneof: [
              "facebookToken"
            ]
          },
          _appleToken: {
            oneof: [
              "appleToken"
            ]
          },
          _tiktokToken: {
            oneof: [
              "tiktokToken"
            ]
          }
        },
        fields: {
          googleToken: {
            type: "string",
            id: 1,
            options: {
              proto3_optional: true
            }
          },
          facebookToken: {
            type: "string",
            id: 2,
            options: {
              proto3_optional: true
            }
          },
          appleToken: {
            type: "string",
            id: 3,
            options: {
              proto3_optional: true
            }
          },
          tiktokToken: {
            type: "string",
            id: 4,
            options: {
              proto3_optional: true
            }
          }
        }
      }
    }
  }
});

module.exports = $root;



//////////////////
// WEBPACK FOOTER
// ./static/proto/proto.js
// module id = HYW6
// module chunks = 15